import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api-client";

export type MediaAsset = {
    id: string;
    kind: "IMAGE" | "VIDEO" | "FILE";
    filename: string;
    mimeType: string;
    sizeBytes: number;
    width: number | null;
    height: number | null;
    durationMs: number | null;
    url: string;
    thumbnailUrl: string | null;
    createdAt: string;
};

const KEY = ["media"] as const;

export function useMediaLibrary() {
    return useQuery({ queryKey: KEY, queryFn: () => api.get<MediaAsset[]>("/api/media") });
}

export function useUploadMedia() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (file: File) => {
            const form = new FormData();
            form.append("file", file);
            return api.post<MediaAsset>("/api/media", form);
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
    });
}

export function useDeleteMedia() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => api.delete(`/api/media/${id}`),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
    });
}

export function formatBytes(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
